import { render, staticRenderFns } from "./comissions.vue?vue&type=template&id=8f21aa7e"
import script from "./comissions.vue?vue&type=script&lang=js"
export * from "./comissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports